import React from 'react';


const Heading = ({ title, subtitle, maintitle }) => {
  return (
    <div className="flex flex-col">
      {maintitle && (
        <div className="flex items-center mb-2">
          {/* <div className="h-[2px] bg-[#9fe2d8] w-8 mr-2"></div> */}
          <p className="text-md text-[#005eb8] font-[500]">{maintitle}</p>
        </div>
      )}
      
      <div className="relative z-0 items-center text-center">
  <h1 className="text-[55px] font-[700] text-black mb-1 relative">
    <span>{title}</span>
  </h1>
</div>

      <p className="text-[18px] font-[500] text-[#8d8d91] mt-2 text-center">{subtitle}</p>
    </div>
  );
};

export default Heading;
